import React, { lazy, Suspense, useEffect, useRef, useState } from "react";
import axios from "axios";
import "leaflet/dist/leaflet.css";

import HomeHero from "../components/HomeHero";
import EventList from "../components/EventList";
import AnnouncementBar from "../components/AnnouncementBar";

import styles from "./HomePage.module.css";

const VenueMap = lazy(() => import("../components/VenueMap"));

const HomePage = () => {
  const [events, setEvents] = useState([]);
  const [announcement, setAnnouncement] = useState(null);
    // お知らせ取得
    useEffect(() => {
      axios
        .get(`${process.env.REACT_APP_API_URL}/announcement/top`)
        .then((res) => setAnnouncement(res.data))
        .catch(() => setAnnouncement(null));
    }, []);
  const [showMap, setShowMap] = useState(false);
  const mapSectionRef = useRef(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/events`, { params: { limit: 8, upcoming: true } })
      .then((res) => setEvents(res.data.events));
  }, []);

  useEffect(() => {
    const el = mapSectionRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          setShowMap(true);
          observer.disconnect();
        }
      },
      { rootMargin: '200px 0px' }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* ① 分岐ヒーロー */}
      <HomeHero />

      {/* お知らせバー（開催予定イベントの上） */}
      <AnnouncementBar announcement={announcement} />

      <div className={styles.wrapper}>
        {events.length >= 5 && (
          <section
            id="upcoming-events"
            className={`${styles.section} ${styles.upcomingSection}`}
          >
            <div className={styles.sectionHeader}>
              <h2 className={styles.sectionTitle}>開催予定イベント</h2>
              <a className={styles.more} href="/events">→</a>
            </div>
            <EventList events={events} variant="carousel" />
          </section>
        )}

        {/* ③ 会場マップ（波弱め） */}
        <section ref={mapSectionRef} className={`${styles.section} ${styles.mapSection}`}>
          <h2 className={styles.sectionTitle}>会場マップ</h2>
          {showMap ? (
            <Suspense fallback={<div>地図を読み込み中...</div>}>
              <VenueMap />
            </Suspense>
          ) : (
            <div>地図を読み込み中...</div>
          )}
        </section>
      </div>
    </>
  );
};

export default HomePage;
